export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

export function getErrorMessage(error: unknown, fallback = ""): string {
  if (isRecord(error)) {
    if (
      isRecord(error.response) &&
      isRecord(error.response.data) &&
      typeof error.response.data.error === "string"
    ) {
      return error.response.data.error;
    }
    if (typeof error.message === "string") return error.message;
  }
  return typeof error === "string" ? error : fallback;
}
